import React from 'react';
import ImageCarousel from '../ImageCarousel'; // Supprimé useTranslation inutile

const HomeSection = () => {
  return (
    <section id="accueil" className="scroll-mt-20">
      <ImageCarousel />
    </section>
  );
};

export default HomeSection;